import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";
import Vuex from "vuex";
import VueI18n from "vue-i18n";
import "./toast.scss";
import "./main.scss";
import VueChatScroll from "vue-chat-scroll";

import { firestorePlugin } from "vuefire";

import router from "./router";
import store from "./store";
import messages from "./lang";
import NavBar from "@/components/NavBar.vue";
import VueSignaturePad from "vue-signature-pad";
import VueTour from "vue-tour";
import linkify from "vue-linkify";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { datadogRum } from "@datadog/browser-rum";
import movable from "v-movable";

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import AudioVisual from "vue-audio-visual";
Vue.use(AudioVisual);

require("vue-tour/dist/vue-tour.css");

Vue.prototype.$window = window;

Vue.use(NavBar);
Vue.use(firestorePlugin);
Vue.use(Buefy);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueChatScroll);
Vue.use(VueSignaturePad);
Vue.use(VueTour);
Vue.use(movable);
Vue.directive("linkified", linkify);

Vue.config.productionTip = false;

Sentry.init({
  Vue: Vue,
  dsn: "https://17d0bb5c1db34f589616b6dae6fb07a4@o99865.ingest.sentry.io/5720931",
  attachProps: true,
  logErrors: true,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

datadogRum.init({
  applicationId: "4e249e7a-b870-45cb-b47d-4655d670338d",
  clientToken: "pubf1573e2cf98068fc2516ae28472bfd29",
  site: "datadoghq.eu",
  service: "qonda-staging",
  sampleRate: 100,
  trackInteractions: true,
});

export const i18n = new VueI18n({
  locale: "de", // set locale
  messages, // set locale messages
});

new Vue({
  router,
  store,
  i18n,
  watch: {
    $route: {
      handler() {
        if (this.$store.getOrganizationId != this.$route.params.organizationId) {
          this.$store.dispatch("updateOrganizationId", this.$route.params.organizationId);
        }
        if (this.$route.params.organizationId == undefined) {
          // this.$store.dispatch("flushOrganizationData");
        }
        if (this.$route.query.ref) {
          localStorage.ref = this.$route.query.ref;
        }
        if (Object.keys(this.$route.query).includes("close")) {
          window.close();
        }
      },
      immediate: true,
    },
  },
  render: (h) => h(App),
}).$mount("#app");
